module.exports = "https://cdn.realtymogul.com/static/media/img_leftpanel.ffd6df5f.jpg";